import { I18n } from '@calendly/i18n';
import { RecaptchaChallenge } from '@calendly/recaptcha';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showRecaptchaChallengeSelector } from './selectors';
import { setRecaptchaV2Token } from './slice';
const sectionCss = "sjf34gy";
const Section = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionCss, props.className)} />;
});
export const RecaptchaChallengeSection = ({
  'data-testid': dataTestId = 'invite-flow-recaptcha-challenge',
  ...props
}) => {
  const dispatch = useDispatch();
  const showRecaptchaChallenge = useSelector(showRecaptchaChallengeSelector);
  const handleRecaptchaVerify = useCallback(token => {
    dispatch(setRecaptchaV2Token(token));
  }, [dispatch]);
  if (!showRecaptchaChallenge) return null;
  return <Section {...props} data-testid={dataTestId}>
      <BodyText size="medium" weight="bold">
        {I18n.t('publisher.organization.invite_flow.recaptcha_prompt')}
      </BodyText>
      <RecaptchaChallenge setVerifyCallback={handleRecaptchaVerify} error={false} />
    </Section>;
};

require("./recaptcha_challenge_section.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./recaptcha_challenge_section.js");